import React from 'react';
// @ts-ignore
import ProfImage from '../../assets/team.png'
// @ts-ignore
import FeesImage from '../../assets/rupee.png'
// @ts-ignore
import GetStartedImage from '../../assets/stopwatch.png'
// @ts-ignore
import ScanImage from '../../assets/scan.png'
// @ts-ignore
import DeliveryImage from '../../assets/delivery.png'
// @ts-ignore
import TakeAwayImage from '../../assets/scan.png'

const ValueProposition = () => {
  return (
    <section className="bg-gray-50 py-20">
      <div className="container mx-auto px-6 text-center">
        <h2 className="text-4xl md:text-4xl font-bold text-gray-800 mb-16 leading-snug">
          No App Install, Get Started in just{" "}
          <span className="text-[#6cbb23] hover:text-green-700 transition-colors duration-300">
            <strong>1 Minute</strong>
          </span>
        </h2>

        <div className="flex flex-col md:flex-row gap-10 justify-center items-stretch">
          {/* Card 1 */}
          <div className="bg-white rounded-2xl shadow-lg hover:shadow-xl transition-shadow duration-300 p-8 flex-1 max-w-sm mx-auto">
            <img
              src={ScanImage}
              alt="QR Code Order"
              className="mx-auto mb-6 h-24 w-24"
            />
            <h3 className="text-2xl font-semibold text-gray-800 mb-3">
              QR Code Order Placing
            </h3>
            <p className="text-gray-600">
              No hassle to install any app. Customers can scan a QR code and place orders using your digital menu.
            </p>
          </div>

          {/* Card 2 */}
          <div className="bg-white rounded-2xl shadow-lg hover:shadow-xl transition-shadow duration-300 p-8 flex-1 max-w-sm mx-auto">
            <img
              src={DeliveryImage}
              alt="Delivery & Take Away"
              className="mx-auto mb-6 h-24 w-24"
            />
            <h3 className="text-2xl font-semibold text-gray-800 mb-3">
              Delivery & Take Away Orders
            </h3>
            <p className="text-gray-600">
              Say bye bye to heavy commissions. Get your delivery and take away orders at no extra cost.
            </p>
          </div>

          {/* Card 3 */}
          <div className="bg-white rounded-2xl shadow-lg hover:shadow-xl transition-shadow duration-300 p-8 flex-1 max-w-sm mx-auto">
            <img
              src={GetStartedImage}
              alt="Get Started Fast"
              className="mx-auto mb-6 h-24 w-24"
            />
            <h3 className="text-2xl font-semibold text-gray-800 mb-3">
              Get Started in 1 Minute
            </h3>
            <p className="text-gray-600">
              Digitize your menu with just a file upload, or let our team do it for you. It's that easy.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ValueProposition;
